var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Megaphone component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconMegaphone extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.845 2.70009C20.19 2.58296 20.5577 2.54904 20.9183 2.60113C21.2798 2.65335 21.6238 2.79052 21.9221 3.00139L21.924 3.00281C22.2227 3.21544 22.4665 3.49607 22.6352 3.82153C22.804 4.14699 22.8929 4.50793 22.8946 4.87453L22.8946 4.878L22.8946 17.7266C22.8929 18.0932 22.804 18.4541 22.6352 18.7796C22.4669 19.1041 22.2241 19.3841 21.9266 19.5965C21.6309 19.8102 21.2888 19.9508 20.9283 20.0069C20.5667 20.0631 20.197 20.0327 19.8495 19.9181L19.8472 19.9174L7.97609 15.9603H6.50635V16.7715C6.50635 17.1854 6.58787 17.5952 6.74627 17.9777C6.90467 18.3601 7.13684 18.7075 7.42952 19.0002C7.72221 19.2929 8.06967 19.5251 8.45208 19.6835C8.83449 19.8419 9.24436 19.9234 9.65827 19.9234C10.0725 19.9234 10.4083 20.2592 10.4083 20.6734C10.4083 21.0876 10.0725 21.4234 9.65827 21.4234C9.04737 21.4234 8.44245 21.3031 7.87806 21.0693C7.31366 20.8355 6.80084 20.4928 6.36886 20.0609C5.93689 19.6289 5.59423 19.1161 5.36045 18.5517C5.12667 17.9873 5.00635 17.3824 5.00635 16.7715V15.8995C4.05064 15.7434 3.16059 15.2914 2.46701 14.5978C2.03504 14.1659 1.69238 13.653 1.4586 13.0886C1.22482 12.5242 1.10449 11.9193 1.10449 11.3084C1.10449 10.0747 1.5946 8.89142 2.46701 8.01901C2.89898 7.58704 3.4118 7.24438 3.9762 7.0106C4.5406 6.77682 5.14552 6.65649 5.75641 6.65649H7.9758L19.845 2.70009ZM20.7039 4.08572C20.577 4.0674 20.4477 4.07941 20.3264 4.12076L20.3215 4.12241L8.84766 7.94701V14.6697L20.3192 18.4936L20.3203 18.4939C20.4419 18.5339 20.5713 18.5444 20.6978 18.5247C20.8246 18.505 20.945 18.4554 21.0489 18.3801L21.054 18.3764C21.1588 18.3018 21.2444 18.2033 21.3036 18.0891C21.3626 17.9753 21.3938 17.8492 21.3946 17.7211V4.88007C21.3938 4.75193 21.3626 4.62579 21.3036 4.51201C21.2446 4.39817 21.1594 4.29996 21.055 4.22545C20.9506 4.15186 20.8303 4.10398 20.7039 4.08572ZM5.75641 8.15649C5.3425 8.15649 4.93264 8.23802 4.55023 8.39642C4.16782 8.55482 3.82035 8.78699 3.52767 9.07967C2.93657 9.67077 2.60449 10.4725 2.60449 11.3084C2.60449 11.7223 2.68602 12.1322 2.84442 12.5146C3.00282 12.897 3.23499 13.2445 3.52767 13.5372C4.11877 14.1283 4.92047 14.4603 5.75641 14.4603H7.34757V8.15649H5.75641Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconMegaphone.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconMegaphone.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconMegaphone.prototype, "size", void 0);
if (customElements.get('cat-icon-megaphone') === undefined) {
    customElements.define('cat-icon-megaphone', BlocksIconMegaphone);
}
